import AuthPage from "components/shared/AuthPage";

import type { TSettingsPage } from "./../../components/Settings/index";
import SettingComponent from "./../../components/Settings/index";

interface ISettingsContainer {
    page?: TSettingsPage | undefined;
}

const Settings = ({ page }: ISettingsContainer) => {
    return (
        <AuthPage userAuthenticated={true}>
            <SettingComponent page={page} />
        </AuthPage>
    );
};

export default Settings;
